const COLORS = ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC000', '#5B9BD5', '#70AD47', '#264478', '#9B57A0',
  '#636363', '#B85450', '#6C8EBF', '#D6B656', '#82B366', '#E07B53', '#9673A6', '#23445D'];

export function renderSimpleChart(canvas, chartObj, logicalWidth, logicalHeight) {
  const ctx = canvas.getContext('2d');
  const width = logicalWidth || canvas.width;
  const height = logicalHeight || canvas.height;
  const padding = { top: 52, right: 24, bottom: 48, left: 58 };
  const chartWidth = width - padding.left - padding.right;
  const chartHeight = height - padding.top - padding.bottom;
  const chartType = chartObj.chartType || 'bar';

  ctx.clearRect(0, 0, width, height);
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);

  // Title
  ctx.fillStyle = '#333333';
  ctx.font = 'bold 13px Calibri, Arial';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'top';
  ctx.fillText(chartObj.title || 'Chart', width / 2, 8);

  if (chartObj.isCombo) {
    drawComboChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
  } else {
    switch (chartType) {
      case 'bar':
      case 'col':
        drawBarChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'line':
        drawLineChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'pie':
      case 'doughnut':
        drawPieChart(ctx, width / 2, padding.top + chartHeight / 2, Math.min(chartWidth, chartHeight) / 2 - 10, chartObj);
        break;
      case 'area':
        drawLineChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj, true);
        break;
      case 'scatter':
        drawScatterChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'bubble':
        drawBubbleChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'radar':
        drawRadarChart(ctx, width / 2, padding.top + chartHeight / 2, Math.min(chartWidth, chartHeight) / 2 - 10, chartObj);
        break;
      case 'stock':
        drawStockChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'surface':
        drawSurfaceChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'waterfall':
        drawWaterfallChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'funnel':
        drawFunnelChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'treemap':
        drawTreemapChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'sunburst':
        drawSunburstChart(ctx, width / 2, padding.top + chartHeight / 2, Math.min(chartWidth, chartHeight) / 2 - 10, chartObj);
        break;
      case 'boxWhisker':
        drawBoxWhiskerChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      case 'histogram':
        drawHistogramChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
        break;
      default:
        drawBarChart(ctx, padding.left, padding.top, chartWidth, chartHeight, chartObj);
    }
  }

  // Border
  ctx.strokeStyle = '#d0d0d0';
  ctx.lineWidth = 1;
  ctx.strokeRect(0.5, 0.5, width - 1, height - 1);
}

/* ========== HELPER FUNCTIONS ========== */

function drawAxes(ctx, x, y, width, height) {
  ctx.strokeStyle = '#999';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(x, y + height);
  ctx.lineTo(x + width, y + height);
  ctx.moveTo(x, y);
  ctx.lineTo(x, y + height);
  ctx.stroke();
}

function drawGridlines(ctx, x, y, width, height, minValue, range, numGridLines) {
  numGridLines = numGridLines || 5;
  ctx.strokeStyle = '#E0E0E0';
  ctx.lineWidth = 1;
  for (var i = 0; i <= numGridLines; i++) {
    var gy = y + height - (i / numGridLines) * height;
    ctx.beginPath();
    ctx.moveTo(x, gy);
    ctx.lineTo(x + width, gy);
    ctx.stroke();
    var val = minValue + (i / numGridLines) * range;
    ctx.fillStyle = '#888';
    ctx.font = '9px Arial';
    ctx.textAlign = 'right';
    ctx.textBaseline = 'middle';
    ctx.fillText(val % 1 === 0 ? val.toString() : val.toFixed(1), x - 4, gy);
  }
}

function drawLegend(ctx, x, y, width, height, seriesArr, options) {
  if (!seriesArr || seriesArr.length === 0) return;
  var isLine = options && options.lineStyle;
  ctx.font = '9px Calibri, Arial';
  ctx.textBaseline = 'middle';
  var totalW = 0;
  seriesArr.forEach(function(s) { totalW += 14 + ctx.measureText(s.name).width + 16; });
  var legendX = x + (width - totalW) / 2;
  var legendY = y + height + 22;
  seriesArr.forEach(function(s, i) {
    var color = COLORS[i % COLORS.length];
    if (isLine) {
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(legendX, legendY);
      ctx.lineTo(legendX + 10, legendY);
      ctx.stroke();
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(legendX + 5, legendY, 2.5, 0, Math.PI * 2);
      ctx.fill();
    } else {
      ctx.fillStyle = color;
      ctx.fillRect(legendX, legendY - 5, 10, 10);
    }
    ctx.fillStyle = '#333';
    ctx.textAlign = 'left';
    ctx.fillText(s.name, legendX + 14, legendY);
    legendX += 14 + ctx.measureText(s.name).width + 16;
  });
}

function drawCategoryLabels(ctx, x, y, height, cats, numCategories, groupWidth) {
  for (var i = 0; i < numCategories; i++) {
    ctx.fillStyle = '#666';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(cats[i] || ('' + (i + 1)), x + i * groupWidth + groupWidth / 2, y + height + 6);
  }
}

function getMinMaxRange(seriesArr) {
  var allVals = seriesArr.flatMap(function(s) { return s.data; });
  var maxValue = Math.max.apply(null, allVals.concat([0])) || 100;
  var minValue = Math.min.apply(null, allVals.concat([0]));
  var range = maxValue - minValue || 100;
  return { minValue: minValue, maxValue: maxValue, range: range };
}

/* ========== BAR CHART ========== */

export function drawBarChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;
  var numSeries = seriesArr.length;
  var numCategories = Math.max.apply(null, seriesArr.map(function(s) { return s.data.length; }));
  if (numCategories === 0) return;

  var mmr = getMinMaxRange(seriesArr);
  var groupWidth = width / numCategories;
  var barWidth = (groupWidth * 0.8) / numSeries;
  var groupPad = groupWidth * 0.1;

  drawGridlines(ctx, x, y, width, height, mmr.minValue, mmr.range);

  seriesArr.forEach(function(series, sIdx) {
    series.data.forEach(function(value, cIdx) {
      var barHeight = ((value - mmr.minValue) / mmr.range) * height;
      var barX = x + cIdx * groupWidth + groupPad + sIdx * barWidth;
      var barY = y + height - barHeight;
      ctx.fillStyle = COLORS[sIdx % COLORS.length];
      ctx.fillRect(barX, barY, barWidth, barHeight);
    });
  });

  drawCategoryLabels(ctx, x, y, height, chartObj.categories || [], numCategories, groupWidth);
  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr);
}

/* ========== COMBO CHART ========== */

export function drawComboChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var barSeries = seriesArr.filter(function(s) { return s.renderType === 'bar' || s.renderType === 'col'; });
  var lineSeries = seriesArr.filter(function(s) { return s.renderType !== 'bar' && s.renderType !== 'col'; });
  var numCategories = Math.max.apply(null, seriesArr.map(function(s) { return s.data.length; }).concat([1]));

  var mmr = getMinMaxRange(seriesArr);
  var groupWidth = width / numCategories;

  drawGridlines(ctx, x, y, width, height, mmr.minValue, mmr.range);

  if (barSeries.length > 0) {
    var numBarSeries = barSeries.length;
    var barWidth = (groupWidth * 0.8) / numBarSeries;
    var groupPad = groupWidth * 0.1;

    barSeries.forEach(function(series, sIdx) {
      var globalIdx = seriesArr.indexOf(series);
      series.data.forEach(function(value, cIdx) {
        var barHeight = ((value - mmr.minValue) / mmr.range) * height;
        var barX = x + cIdx * groupWidth + groupPad + sIdx * barWidth;
        var barY = y + height - barHeight;
        ctx.fillStyle = COLORS[globalIdx % COLORS.length];
        ctx.fillRect(barX, barY, barWidth, barHeight);
      });
    });
  }

  lineSeries.forEach(function(series) {
    var globalIdx = seriesArr.indexOf(series);
    var data = series.data;
    if (!data || data.length === 0) return;
    var color = COLORS[globalIdx % COLORS.length];
    var pointSpacing = groupWidth;

    ctx.strokeStyle = color;
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    data.forEach(function(value, index) {
      var px = x + index * pointSpacing + pointSpacing / 2;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      if (index === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    });
    ctx.stroke();

    data.forEach(function(value, index) {
      var px = x + index * pointSpacing + pointSpacing / 2;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(px, py, 3.5, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 1;
      ctx.stroke();
    });
  });

  drawCategoryLabels(ctx, x, y, height, chartObj.categories || [], numCategories, groupWidth);
  drawAxes(ctx, x, y, width, height);

  // Combo legend with mixed styles
  ctx.font = '9px Calibri, Arial';
  ctx.textBaseline = 'middle';
  var totalLegendW = 0;
  seriesArr.forEach(function(s) { totalLegendW += 14 + ctx.measureText(s.name).width + 16; });
  var legendX = x + (width - totalLegendW) / 2;
  var legendY = y + height + 22;
  seriesArr.forEach(function(s, i) {
    var color = COLORS[i % COLORS.length];
    var isLine = s.renderType !== 'bar' && s.renderType !== 'col';
    if (isLine) {
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(legendX, legendY);
      ctx.lineTo(legendX + 10, legendY);
      ctx.stroke();
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(legendX + 5, legendY, 2.5, 0, Math.PI * 2);
      ctx.fill();
    } else {
      ctx.fillStyle = color;
      ctx.fillRect(legendX, legendY - 5, 10, 10);
    }
    ctx.fillStyle = '#333';
    ctx.textAlign = 'left';
    ctx.fillText(s.name, legendX + 14, legendY);
    legendX += 14 + ctx.measureText(s.name).width + 16;
  });
}

/* ========== LINE CHART ========== */

export function drawLineChart(ctx, x, y, width, height, chartObj, fillArea) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var mmr = getMinMaxRange(seriesArr);

  drawGridlines(ctx, x, y, width, height, mmr.minValue, mmr.range);

  seriesArr.forEach(function(series, sIdx) {
    var data = series.data;
    if (!data || data.length === 0) return;
    var pointSpacing = width / Math.max(1, data.length - 1);
    var color = COLORS[sIdx % COLORS.length];

    if (fillArea) {
      ctx.globalAlpha = 0.2;
      ctx.fillStyle = color;
      ctx.beginPath();
      data.forEach(function(value, index) {
        var px = x + index * pointSpacing;
        var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
        if (index === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
      });
      ctx.lineTo(x + (data.length - 1) * pointSpacing, y + height);
      ctx.lineTo(x, y + height);
      ctx.closePath();
      ctx.fill();
      ctx.globalAlpha = 1;
    }

    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();
    data.forEach(function(value, index) {
      var px = x + index * pointSpacing;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      if (index === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    });
    ctx.stroke();

    data.forEach(function(value, index) {
      var px = x + index * pointSpacing;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(px, py, 3, 0, Math.PI * 2);
      ctx.fill();
    });
  });

  var cats = chartObj.categories || [];
  var numCategories = Math.max.apply(null, seriesArr.map(function(s) { return s.data.length; }));
  var catSpacing = width / Math.max(1, numCategories - 1);
  for (var i = 0; i < numCategories; i++) {
    ctx.fillStyle = '#666';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(cats[i] || ('' + (i + 1)), x + i * catSpacing, y + height + 6);
  }

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr, { lineStyle: true });
}

/* ========== PIE / DOUGHNUT CHART ========== */

export function drawPieChart(ctx, centerX, centerY, radius, chartObj) {
  var seriesData = chartObj && chartObj.series && chartObj.series[0] ? chartObj.series[0].data : null;
  if (!seriesData || seriesData.length === 0) return;
  var cats = chartObj.categories || [];
  var total = seriesData.reduce(function(sum, value) { return sum + Math.abs(value); }, 0);
  if (total === 0) return;
  var currentAngle = -Math.PI / 2;
  var isDoughnut = chartObj.chartType === 'doughnut';

  seriesData.forEach(function(value, index) {
    var sliceAngle = (Math.abs(value) / total) * Math.PI * 2;
    ctx.fillStyle = COLORS[index % COLORS.length];
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.arc(centerX, centerY, radius, currentAngle, currentAngle + sliceAngle);
    ctx.closePath();
    ctx.fill();
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 2;
    ctx.stroke();

    var midAngle = currentAngle + sliceAngle / 2;
    var labelR = radius * 0.65;
    var lx = centerX + Math.cos(midAngle) * labelR;
    var ly = centerY + Math.sin(midAngle) * labelR;
    var pct = ((Math.abs(value) / total) * 100).toFixed(0);
    if (sliceAngle > 0.15) {
      ctx.fillStyle = '#fff';
      ctx.font = 'bold 10px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(pct + '%', lx, ly);
    }
    currentAngle += sliceAngle;
  });

  if (isDoughnut) {
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius * 0.5, 0, Math.PI * 2);
    ctx.fill();
  }

  // Legend
  var legendY = centerY + radius + 16;
  var legendX = centerX - (seriesData.length * 40) / 2;
  seriesData.forEach(function(value, i) {
    ctx.fillStyle = COLORS[i % COLORS.length];
    ctx.fillRect(legendX, legendY, 8, 8);
    ctx.fillStyle = '#333';
    ctx.font = '9px Arial';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    var label = cats[i] || ('' + (i + 1));
    ctx.fillText(label, legendX + 12, legendY);
    legendX += ctx.measureText(label).width + 24;
  });
}

/* ========== SCATTER CHART (XY) ========== */

export function drawScatterChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var allX = [], allY = [];
  seriesArr.forEach(function(s) {
    var xd = s.xData || s.data.map(function(_, i) { return i; });
    xd.forEach(function(v) { allX.push(v); });
    s.data.forEach(function(v) { allY.push(v); });
  });

  var xMin = Math.min.apply(null, allX);
  var xMax = Math.max.apply(null, allX);
  var yMin = Math.min.apply(null, allY.concat([0]));
  var yMax = Math.max.apply(null, allY.concat([0]));
  var xRange = xMax - xMin || 1;
  var yRange = yMax - yMin || 1;

  drawGridlines(ctx, x, y, width, height, yMin, yRange);

  // X-axis gridlines
  ctx.strokeStyle = '#E0E0E0';
  ctx.lineWidth = 1;
  for (var gi = 0; gi <= 5; gi++) {
    var gx = x + (gi / 5) * width;
    ctx.beginPath();
    ctx.moveTo(gx, y);
    ctx.lineTo(gx, y + height);
    ctx.stroke();
    var xv = xMin + (gi / 5) * xRange;
    ctx.fillStyle = '#888';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(xv % 1 === 0 ? xv.toString() : xv.toFixed(1), gx, y + height + 4);
  }

  seriesArr.forEach(function(series, sIdx) {
    var xd = series.xData || series.data.map(function(_, i) { return i; });
    var color = COLORS[sIdx % COLORS.length];
    series.data.forEach(function(yVal, i) {
      var xVal = xd[i] !== undefined ? xd[i] : i;
      var px = x + ((xVal - xMin) / xRange) * width;
      var py = y + height - ((yVal - yMin) / yRange) * height;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(px, py, 4, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#fff';
      ctx.lineWidth = 1;
      ctx.stroke();
    });
  });

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr);
}

/* ========== BUBBLE CHART ========== */

export function drawBubbleChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var allX = [], allY = [], allSizes = [];
  seriesArr.forEach(function(s) {
    var xd = s.xData || s.data.map(function(_, i) { return i; });
    xd.forEach(function(v) { allX.push(v); });
    s.data.forEach(function(v) { allY.push(v); });
    if (s.bubbleSizes) s.bubbleSizes.forEach(function(v) { allSizes.push(Math.abs(v)); });
  });

  var xMin = Math.min.apply(null, allX);
  var xMax = Math.max.apply(null, allX);
  var yMin = Math.min.apply(null, allY.concat([0]));
  var yMax = Math.max.apply(null, allY.concat([0]));
  var xRange = xMax - xMin || 1;
  var yRange = yMax - yMin || 1;
  var maxSize = allSizes.length > 0 ? Math.max.apply(null, allSizes.concat([1])) : 1;

  drawGridlines(ctx, x, y, width, height, yMin, yRange);

  seriesArr.forEach(function(series, sIdx) {
    var xd = series.xData || series.data.map(function(_, i) { return i; });
    var sizes = series.bubbleSizes || series.data.map(function() { return maxSize; });
    var color = COLORS[sIdx % COLORS.length];

    series.data.forEach(function(yVal, i) {
      var xVal = xd[i] !== undefined ? xd[i] : i;
      var px = x + ((xVal - xMin) / xRange) * width;
      var py = y + height - ((yVal - yMin) / yRange) * height;
      var sizeVal = Math.abs(sizes[i] || 1);
      var r = Math.max(4, Math.min(30, (sizeVal / maxSize) * 25));

      ctx.globalAlpha = 0.55;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(px, py, r, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;
      ctx.strokeStyle = color;
      ctx.lineWidth = 1.5;
      ctx.stroke();
    });
  });

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr);
}

/* ========== RADAR CHART (Spider / Polar) ========== */

export function drawRadarChart(ctx, centerX, centerY, radius, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;
  var cats = chartObj.categories || [];
  var numAxes = Math.max.apply(null, seriesArr.map(function(s) { return s.data.length; }).concat([1]));
  var angleStep = (Math.PI * 2) / numAxes;
  var allVals = seriesArr.flatMap(function(s) { return s.data; });
  var maxValue = Math.max.apply(null, allVals.concat([1]));

  // Draw web rings
  var rings = 4;
  for (var r = 1; r <= rings; r++) {
    var ringRadius = (r / rings) * radius;
    ctx.strokeStyle = '#D8D8D8';
    ctx.lineWidth = 0.7;
    ctx.beginPath();
    for (var ai = 0; ai <= numAxes; ai++) {
      var angle = -Math.PI / 2 + ai * angleStep;
      var px = centerX + Math.cos(angle) * ringRadius;
      var py = centerY + Math.sin(angle) * ringRadius;
      if (ai === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    }
    ctx.closePath();
    ctx.stroke();
  }

  // Draw axis lines and labels
  for (var ai2 = 0; ai2 < numAxes; ai2++) {
    var angle2 = -Math.PI / 2 + ai2 * angleStep;
    var px2 = centerX + Math.cos(angle2) * radius;
    var py2 = centerY + Math.sin(angle2) * radius;
    ctx.strokeStyle = '#CCCCCC';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.lineTo(px2, py2);
    ctx.stroke();

    var labelR = radius + 12;
    var lx = centerX + Math.cos(angle2) * labelR;
    var ly = centerY + Math.sin(angle2) * labelR;
    ctx.fillStyle = '#555';
    ctx.font = '9px Arial';
    ctx.textAlign = Math.abs(Math.cos(angle2)) < 0.01 ? 'center' : Math.cos(angle2) > 0 ? 'left' : 'right';
    ctx.textBaseline = Math.abs(Math.sin(angle2)) < 0.01 ? 'middle' : Math.sin(angle2) > 0 ? 'top' : 'bottom';
    ctx.fillText(cats[ai2] || ('' + (ai2 + 1)), lx, ly);
  }

  // Draw data polygons
  seriesArr.forEach(function(series, sIdx) {
    var data = series.data;
    if (!data || data.length === 0) return;
    var color = COLORS[sIdx % COLORS.length];

    ctx.globalAlpha = 0.15;
    ctx.fillStyle = color;
    ctx.beginPath();
    data.forEach(function(val, i) {
      var rr = (val / maxValue) * radius;
      var ang = -Math.PI / 2 + i * angleStep;
      var ppx = centerX + Math.cos(ang) * rr;
      var ppy = centerY + Math.sin(ang) * rr;
      if (i === 0) ctx.moveTo(ppx, ppy);
      else ctx.lineTo(ppx, ppy);
    });
    ctx.closePath();
    ctx.fill();
    ctx.globalAlpha = 1;

    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();
    data.forEach(function(val, i) {
      var rr = (val / maxValue) * radius;
      var ang = -Math.PI / 2 + i * angleStep;
      var ppx = centerX + Math.cos(ang) * rr;
      var ppy = centerY + Math.sin(ang) * rr;
      if (i === 0) ctx.moveTo(ppx, ppy);
      else ctx.lineTo(ppx, ppy);
    });
    ctx.closePath();
    ctx.stroke();

    data.forEach(function(val, i) {
      var rr = (val / maxValue) * radius;
      var ang = -Math.PI / 2 + i * angleStep;
      var ppx = centerX + Math.cos(ang) * rr;
      var ppy = centerY + Math.sin(ang) * rr;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(ppx, ppy, 3, 0, Math.PI * 2);
      ctx.fill();
    });
  });
}

/* ========== STOCK CHART (OHLC / High-Low-Close) ========== */

export function drawStockChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var allVals = seriesArr.flatMap(function(s) { return s.data; });
  var maxValue = Math.max.apply(null, allVals.concat([0])) || 100;
  var minValue = Math.min.apply(null, allVals.concat([0]));
  var range = maxValue - minValue || 100;
  var numPoints = Math.max.apply(null, seriesArr.map(function(s) { return s.data.length; }));
  var cats = chartObj.categories || [];

  drawGridlines(ctx, x, y, width, height, minValue, range);

  var colW = width / Math.max(numPoints, 1);

  if (seriesArr.length >= 3) {
    var hasOpen = seriesArr.length >= 4;
    var highS = hasOpen ? seriesArr[1] : seriesArr[0];
    var lowS  = hasOpen ? seriesArr[2] : seriesArr[1];
    var closeS = hasOpen ? seriesArr[3] : seriesArr[2];
    var openS = hasOpen ? seriesArr[0] : null;

    for (var i = 0; i < numPoints; i++) {
      var cx = x + i * colW + colW / 2;
      var highVal = highS && highS.data[i] !== undefined ? highS.data[i] : 0;
      var lowVal  = lowS && lowS.data[i] !== undefined ? lowS.data[i] : 0;
      var closeVal = closeS && closeS.data[i] !== undefined ? closeS.data[i] : 0;
      var openVal  = openS && openS.data[i] !== undefined ? openS.data[i] : closeVal;

      var highY = y + height - ((highVal - minValue) / range) * height;
      var lowY  = y + height - ((lowVal - minValue) / range) * height;
      var openY = y + height - ((openVal - minValue) / range) * height;
      var closeY = y + height - ((closeVal - minValue) / range) * height;

      var bullish = closeVal >= openVal;
      var barColor = bullish ? '#70AD47' : '#ED7D31';

      ctx.strokeStyle = '#555';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(cx, highY);
      ctx.lineTo(cx, lowY);
      ctx.stroke();

      var bodyTop = Math.min(openY, closeY);
      var bodyHeight = Math.max(Math.abs(openY - closeY), 1);
      var bodyW = colW * 0.5;
      ctx.fillStyle = barColor;
      ctx.fillRect(cx - bodyW / 2, bodyTop, bodyW, bodyHeight);
      ctx.strokeStyle = barColor;
      ctx.lineWidth = 1;
      ctx.strokeRect(cx - bodyW / 2, bodyTop, bodyW, bodyHeight);
    }
  } else {
    seriesArr.forEach(function(series, sIdx) {
      var color = COLORS[sIdx % COLORS.length];
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.beginPath();
      series.data.forEach(function(val, i) {
        var px = x + i * colW + colW / 2;
        var py = y + height - ((val - minValue) / range) * height;
        if (i === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
      });
      ctx.stroke();
    });
  }

  for (var ci = 0; ci < numPoints; ci++) {
    ctx.fillStyle = '#666';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(cats[ci] || ('' + (ci + 1)), x + ci * colW + colW / 2, y + height + 6);
  }

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr);
}

/* ========== SURFACE CHART (area-fill approximation) ========== */

export function drawSurfaceChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var mmr = getMinMaxRange(seriesArr);
  drawGridlines(ctx, x, y, width, height, mmr.minValue, mmr.range);

  seriesArr.forEach(function(series, sIdx) {
    var data = series.data;
    if (!data || data.length === 0) return;
    var pointSpacing = width / Math.max(1, data.length - 1);
    var color = COLORS[sIdx % COLORS.length];

    ctx.globalAlpha = 0.3;
    ctx.fillStyle = color;
    ctx.beginPath();
    data.forEach(function(value, index) {
      var px = x + index * pointSpacing;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      if (index === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    });
    ctx.lineTo(x + (data.length - 1) * pointSpacing, y + height);
    ctx.lineTo(x, y + height);
    ctx.closePath();
    ctx.fill();
    ctx.globalAlpha = 1;

    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();
    data.forEach(function(value, index) {
      var px = x + index * pointSpacing;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      if (index === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    });
    ctx.stroke();
  });

  var cats = chartObj.categories || [];
  var numCats = Math.max.apply(null, seriesArr.map(function(s) { return s.data.length; }));
  var catSpacing = width / Math.max(1, numCats - 1);
  for (var ci = 0; ci < numCats; ci++) {
    ctx.fillStyle = '#666';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(cats[ci] || ('' + (ci + 1)), x + ci * catSpacing, y + height + 6);
  }

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr, { lineStyle: true });
}

/* ========== WATERFALL CHART ========== */

export function drawWaterfallChart(ctx, x, y, width, height, chartObj) {
  var series = chartObj && chartObj.series && chartObj.series[0] ? chartObj.series[0] : null;
  if (!series || series.data.length === 0) return;
  var data = series.data;
  var cats = chartObj.categories || [];
  var numBars = data.length;

  var cumulative = 0;
  var segments = data.map(function(val) {
    var start = cumulative;
    cumulative += val;
    return { start: start, end: cumulative, value: val };
  });

  var allEnds = segments.map(function(s) { return s.end; });
  var allStarts = segments.map(function(s) { return s.start; });
  var minValue = Math.min.apply(null, [0].concat(allStarts).concat(allEnds));
  var maxValue = Math.max.apply(null, [0].concat(allStarts).concat(allEnds));
  var range = maxValue - minValue || 100;

  drawGridlines(ctx, x, y, width, height, minValue, range);

  var groupWidth = width / numBars;
  var barWidth = groupWidth * 0.6;

  segments.forEach(function(seg, i) {
    var startY = y + height - ((seg.start - minValue) / range) * height;
    var endY   = y + height - ((seg.end - minValue) / range) * height;
    var barTop = Math.min(startY, endY);
    var barH   = Math.max(Math.abs(startY - endY), 1);
    var barX   = x + i * groupWidth + (groupWidth - barWidth) / 2;

    ctx.fillStyle = seg.value >= 0 ? '#70AD47' : '#ED7D31';
    ctx.fillRect(barX, barTop, barWidth, barH);

    if (i < numBars - 1) {
      ctx.strokeStyle = '#999';
      ctx.lineWidth = 1;
      ctx.setLineDash([3, 3]);
      ctx.beginPath();
      ctx.moveTo(barX + barWidth, endY);
      ctx.lineTo(x + (i + 1) * groupWidth + (groupWidth - barWidth) / 2, endY);
      ctx.stroke();
      ctx.setLineDash([]);
    }
  });

  drawCategoryLabels(ctx, x, y, height, cats, numBars, groupWidth);
  drawAxes(ctx, x, y, width, height);
}

/* ========== FUNNEL CHART ========== */

export function drawFunnelChart(ctx, x, y, width, height, chartObj) {
  var series = chartObj && chartObj.series && chartObj.series[0] ? chartObj.series[0] : null;
  if (!series || series.data.length === 0) return;
  var data = series.data;
  var cats = chartObj.categories || [];
  var n = data.length;
  var maxVal = Math.max.apply(null, data.map(function(v) { return Math.abs(v); }).concat([1]));
  var sliceH = height / n;

  data.forEach(function(val, i) {
    var ratio = Math.abs(val) / maxVal;
    var sliceWidth = ratio * width;
    var sliceX = x + (width - sliceWidth) / 2;
    var sliceY = y + i * sliceH;

    ctx.fillStyle = COLORS[i % COLORS.length];
    ctx.fillRect(sliceX, sliceY + 1, sliceWidth, sliceH - 2);

    ctx.fillStyle = '#fff';
    ctx.font = 'bold 10px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    var label = cats[i] || ('' + (i + 1));
    var valueStr = val.toLocaleString();
    if (sliceWidth > 50) {
      ctx.fillText(label + ': ' + valueStr, x + width / 2, sliceY + sliceH / 2);
    }
  });
}

/* ========== TREEMAP CHART ========== */

export function drawTreemapChart(ctx, x, y, width, height, chartObj) {
  var series = chartObj && chartObj.series && chartObj.series[0] ? chartObj.series[0] : null;
  if (!series || series.data.length === 0) return;
  var data = series.data.map(function(v) { return Math.abs(v); });
  var cats = chartObj.categories || [];
  var total = data.reduce(function(a, b) { return a + b; }, 0);
  if (total === 0) return;

  var remaining = data.map(function(v, i) { return { value: v, index: i }; });
  remaining.sort(function(a, b) { return b.value - a.value; });

  var rects = [];

  function layout(items, bx, by, bw, bh) {
    if (items.length === 0) return;
    if (items.length === 1) {
      rects.push({ x: bx, y: by, w: bw, h: bh, index: items[0].index, value: items[0].value });
      return;
    }
    var totalVal = items.reduce(function(a, b) { return a + b.value; }, 0);
    if (totalVal === 0) return;
    var sum = 0;
    var splitIdx = 0;
    for (var i = 0; i < items.length; i++) {
      sum += items[i].value;
      if (sum >= totalVal / 2) { splitIdx = i; break; }
    }
    splitIdx = Math.max(0, Math.min(items.length - 2, splitIdx));
    var left = items.slice(0, splitIdx + 1);
    var right = items.slice(splitIdx + 1);
    var leftTotal = left.reduce(function(a, b) { return a + b.value; }, 0);
    var ratio = leftTotal / totalVal;

    if (bw >= bh) {
      layout(left, bx, by, bw * ratio, bh);
      layout(right, bx + bw * ratio, by, bw * (1 - ratio), bh);
    } else {
      layout(left, bx, by, bw, bh * ratio);
      layout(right, bx, by + bh * ratio, bw, bh * (1 - ratio));
    }
  }

  layout(remaining, x, y, width, height);

  rects.forEach(function(r) {
    ctx.fillStyle = COLORS[r.index % COLORS.length];
    ctx.fillRect(r.x + 1, r.y + 1, r.w - 2, r.h - 2);
    ctx.strokeStyle = '#fff';
    ctx.lineWidth = 2;
    ctx.strokeRect(r.x + 1, r.y + 1, r.w - 2, r.h - 2);

    if (r.w > 30 && r.h > 18) {
      var label = cats[r.index] || ('' + (r.index + 1));
      ctx.fillStyle = '#fff';
      ctx.font = r.w > 60 && r.h > 30 ? 'bold 11px Arial' : '9px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var maxLabelW = r.w - 6;
      var displayLabel = ctx.measureText(label).width > maxLabelW
        ? label.substring(0, Math.floor(maxLabelW / 6)) + '…'
        : label;
      ctx.fillText(displayLabel, r.x + r.w / 2, r.y + r.h / 2);
    }
  });
}

/* ========== SUNBURST CHART ========== */

export function drawSunburstChart(ctx, centerX, centerY, radius, chartObj) {
  var series = chartObj && chartObj.series && chartObj.series[0] ? chartObj.series[0] : null;
  if (!series || series.data.length === 0) return;
  var data = series.data.map(function(v) { return Math.abs(v); });
  var cats = chartObj.categories || [];
  var total = data.reduce(function(a, b) { return a + b; }, 0);
  if (total === 0) return;

  var innerRadius = radius * 0.35;
  var currentAngle = -Math.PI / 2;

  data.forEach(function(val, i) {
    var sliceAngle = (val / total) * Math.PI * 2;
    ctx.fillStyle = COLORS[i % COLORS.length];
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, currentAngle, currentAngle + sliceAngle);
    ctx.arc(centerX, centerY, innerRadius, currentAngle + sliceAngle, currentAngle, true);
    ctx.closePath();
    ctx.fill();
    ctx.strokeStyle = '#fff';
    ctx.lineWidth = 2;
    ctx.stroke();

    if (sliceAngle > 0.2) {
      var midAngle = currentAngle + sliceAngle / 2;
      var labelR = (radius + innerRadius) / 2;
      var lx = centerX + Math.cos(midAngle) * labelR;
      var ly = centerY + Math.sin(midAngle) * labelR;
      var label = cats[i] || ('' + (i + 1));
      ctx.fillStyle = '#fff';
      ctx.font = 'bold 9px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(label, lx, ly);
    }
    currentAngle += sliceAngle;
  });
}

/* ========== BOX & WHISKER CHART ========== */

export function drawBoxWhiskerChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;
  var cats = chartObj.categories || [];

  var allVals = seriesArr.flatMap(function(s) { return s.data; });
  var minValue = Math.min.apply(null, allVals.concat([0]));
  var maxValue = Math.max.apply(null, allVals.concat([0]));
  var range = maxValue - minValue || 100;

  drawGridlines(ctx, x, y, width, height, minValue, range);

  var numGroups = seriesArr.length;
  var groupWidth = width / Math.max(numGroups, 1);

  function toY(val) {
    return y + height - ((val - minValue) / range) * height;
  }

  seriesArr.forEach(function(series, sIdx) {
    var data = series.data.slice().sort(function(a, b) { return a - b; });
    if (data.length === 0) return;

    var q1 = data[Math.floor(data.length * 0.25)];
    var median = data[Math.floor(data.length * 0.5)];
    var q3 = data[Math.floor(data.length * 0.75)];
    var whiskerLow = data[0];
    var whiskerHigh = data[data.length - 1];
    var color = COLORS[sIdx % COLORS.length];

    var cx = x + sIdx * groupWidth + groupWidth / 2;
    var boxW = groupWidth * 0.5;

    // Whisker line
    ctx.strokeStyle = '#555';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(cx, toY(whiskerHigh));
    ctx.lineTo(cx, toY(whiskerLow));
    ctx.stroke();

    // Whisker caps
    ctx.beginPath();
    ctx.moveTo(cx - boxW * 0.3, toY(whiskerHigh));
    ctx.lineTo(cx + boxW * 0.3, toY(whiskerHigh));
    ctx.moveTo(cx - boxW * 0.3, toY(whiskerLow));
    ctx.lineTo(cx + boxW * 0.3, toY(whiskerLow));
    ctx.stroke();

    // Box (Q1 to Q3)
    var boxTop = toY(q3);
    var boxBottom = toY(q1);
    ctx.fillStyle = color;
    ctx.globalAlpha = 0.5;
    ctx.fillRect(cx - boxW / 2, boxTop, boxW, boxBottom - boxTop);
    ctx.globalAlpha = 1;
    ctx.strokeStyle = color;
    ctx.lineWidth = 1.5;
    ctx.strokeRect(cx - boxW / 2, boxTop, boxW, boxBottom - boxTop);

    // Median line
    ctx.strokeStyle = '#333';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(cx - boxW / 2, toY(median));
    ctx.lineTo(cx + boxW / 2, toY(median));
    ctx.stroke();

    // Category label
    ctx.fillStyle = '#666';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(cats[sIdx] || series.name || ('' + (sIdx + 1)), cx, y + height + 6);
  });

  drawAxes(ctx, x, y, width, height);
}

/* ========== HISTOGRAM CHART ========== */

export function drawHistogramChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;
  var series = seriesArr[0];
  var data = series.data;
  if (!data || data.length === 0) return;
  var cats = chartObj.categories || [];

  var maxVal = Math.max.apply(null, data.concat([0])) || 100;
  var minVal = 0;
  var range = maxVal - minVal || 100;
  var numBins = data.length;

  drawGridlines(ctx, x, y, width, height, minVal, range);

  var binWidth = width / numBins;
  data.forEach(function(val, i) {
    var barH = ((val - minVal) / range) * height;
    var barX = x + i * binWidth;
    var barY = y + height - barH;
    ctx.fillStyle = COLORS[0];
    ctx.fillRect(barX, barY, binWidth, barH);
    ctx.strokeStyle = '#fff';
    ctx.lineWidth = 0.5;
    ctx.strokeRect(barX, barY, binWidth, barH);
  });

  var maxLabels = Math.floor(width / 30);
  var step = Math.max(1, Math.ceil(numBins / maxLabels));
  for (var i = 0; i < numBins; i += step) {
    ctx.fillStyle = '#666';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(cats[i] || ('' + (i + 1)), x + i * binWidth + binWidth / 2, y + height + 6);
  }

  drawAxes(ctx, x, y, width, height);
}
